// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invitees-list-item__displayname[data-v-43ae7fe4]{margin-bottom:17px}.avatar-participation-status[data-v-43ae7fe4]{margin-top:5px}", ""]);
// Exports
module.exports = exports;
